import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Container, TopInfoWrapper } from './styles'
import { InfoBlock } from '../../../../../components'
import { timeConverterMMDDYYHHMM } from '../../../../../utils/dates'
import { useNavigate } from 'react-router-dom'

type OverviewProps = {
  backup: any
}

const Overview: FC<OverviewProps> = ({ backup }) => {
  const [t] = useTranslation()
  const navigate = useNavigate()

  const specifications = [
    {
      title: t("ID"),
      id: '1',
      value: backup.id
    },
    {
      title: t("SIZE"),
      id: '2',
      value: `${backup.size} GB`
    },
    {
      title: t("CREATED_AT"),
      id: '3',
      value: timeConverterMMDDYYHHMM(backup.created_at)
    },
    {
      title: t("IS_INCREMENTAL"),
      id: '4',
      value: backup.is_incremental ? t("YES") : t("NO")
    },
    {
      title: t("OBJECT_COUNT"),
      id: '5',
      value: backup.object_count || 'N/A'
    },
    {
      title: t("VOLUME"),
      id: '6',
      value: backup.volume_id ? (
        <span
          style={{ cursor: 'pointer', color: '#1976d2', textDecoration: 'underline' }}
          onClick={() => navigate(`/openstack/volumes/${backup.volume_id}/overview`)}
        >
          {backup.volume_id}
        </span>
      ) : 'N/A'
    },
    {
      title: t("DESCRIPTION"),
      id: '7',
      value: backup.description || 'N/A'
    },
  ]

  return (
    <Container>
      <TopInfoWrapper>
        <InfoBlock
          data={specifications}
          title={t("VOLUME_BACKUP_SPECIFICATIONS")}
          customStyles={{ marginTop: '10px', width: "545px", flex: 'auto 1', marginRight: '10px' }}
        />
      </TopInfoWrapper>
    </Container>
  )
}

export default Overview
